function u(e, n, t, r, a, o, c, f, l) {
  switch (arguments.length) {
    case 1:
      return e;
    case 2:
      return n(e);
    case 3:
      return t(n(e));
    case 4:
      return r(t(n(e)));
    case 5:
      return a(r(t(n(e))));
    case 6:
      return o(a(r(t(n(e)))));
    case 7:
      return c(o(a(r(t(n(e))))));
    case 8:
      return f(c(o(a(r(t(n(e)))))));
    case 9:
      return l(f(c(o(a(r(t(n(e))))))));
    default: {
      for (var s = arguments[0], d = 1; d < arguments.length; d++)
        s = arguments[d](s);
      return s;
    }
  }
}
globalThis && globalThis.__spreadArray;
var h = { _tag: "None" }, k = function(e) {
  return { _tag: "Some", value: e };
}, w = function(e) {
  return e._tag === "Left";
}, b = function(e) {
  return { _tag: "Left", left: e };
}, q = function(e) {
  return { _tag: "Right", right: e };
}, E = h, P = k, j = function(e) {
  return e._tag === "None";
}, A = function(e) {
  return function(n) {
    return j(n) ? e() : n.value;
  };
}, p = A, y = function(e) {
  return e == null ? E : P(e);
};
const i = (e, n) => (t) => (r) => (a) => {
  const o = { ...n, ...r, ...a };
  return t(e, o), o;
}, N = i("carousel_navigated", {
  version: "v0.0.1",
  category: "behavior"
}), S = i("md_contact_api_called", {
  version: "v0.0.1",
  category: "funnel"
}), I = i(
  "content_display_interacted",
  {
    version: "v0.0.1",
    category: "behavior"
  }
), O = i("cta_clicked", {
  version: "v0.0.1",
  category: "behavior"
}), $ = i(
  "form_button_clicked",
  {
    version: "v0.0.1",
    category: "behavior"
  }
), C = i(
  "form_field_interacted",
  {
    version: "v0.0.1",
    category: "behavior"
  }
), L = i(
  "hubspot_request_called",
  {
    version: "v0.0.1",
    category: "behavior"
  }
), T = i("lead_pre_qualified", {
  version: "v0.0.1",
  category: "funnel",
  journey: "credit_analysis",
  element_name: "lead_qualified"
}), Q = i("lead_non_qualified", {
  version: "v0.0.1",
  category: "funnel",
  journey: "lead_creation",
  element_name: "lead_denied"
}), D = i(
  "mkt_lead_pre_qualified",
  {
    version: "v0.0.1",
    category: "funnel",
    journey: "credit_analysis",
    element_name: "lead_qualified"
  }
), H = i(
  "mkt_lead_non_qualified",
  {
    version: "v0.0.1",
    category: "funnel",
    journey: "lead_creation",
    element_name: "lead_denied"
  }
), M = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  carouselNavigated: N,
  contactAPI: S,
  contentDisplayInteracted: I,
  ctaClicked: O,
  formButtonClicked: $,
  formFieldInteracted: C,
  hubspotRequestCalled: L,
  leadPreQualified: T,
  leadNonQualified: Q,
  mktLeadPreQualified: D,
  mktLeadNonQualified: H
}, Symbol.toStringTag, { value: "Module" })), R = (e) => (n) => Object.keys(n).reduce((t, r) => {
  const a = n[r](e);
  return t = { ...t, [r]: a }, t;
}, {});
var F = function(e, n, t, r, a, o, c, f) {
  if (!e) {
    var l;
    if (n === void 0)
      l = new Error(
        "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
      );
    else {
      var s = [t, r, a, o, c, f], d = 0;
      l = new Error(
        n.replace(/%s/g, function() {
          return s[d++];
        })
      ), l.name = "Invariant Violation";
    }
    throw l.framesToPop = 1, l;
  }
}, x = F, g = /* @__PURE__ */ ((e) => (e.AE = "auto_equity", e.AF = "auto_fin", e.BE = "benefits", e.CA = "creditas_auto", e.CR = "cross", e.HE = "home_equity", e.HS = "home_solutions", e.IS = "insurance", e.IN = "institutional", e.MX = "mexico", e.PAE = "partnership_auto_equity", e.PHE = "partnership_home_equity", e.PIS = "partnership_insurance", e))(g || {});
const z = Object.keys(g);
function K(e) {
  return z.includes(e);
}
const V = (e) => (n) => (x(K(e.bu), `Invalid BU value ${e.bu}`), Object.keys(n).reduce((t, r) => {
  const a = n[r]({
    application: e.application,
    bu: g[e.bu]
  });
  return t = { ...t, [r]: a }, t;
}, {})), W = (e) => (n) => {
  const t = e[0]();
  return n.page = t.page, n.identify = t.identify, n.track = t.track, n;
};
var X = b, m = q, v = function(e) {
  return function(n) {
    return G(n) ? n : m(e(n.right));
  };
}, G = w, _ = function(e) {
  return function(n) {
    return n == null ? X(e) : m(n);
  };
};
const J = () => (e, n) => {
  typeof window > "u" || u(
    window.analytics,
    _("nully"),
    v((t) => {
      t.track(e, n);
    })
  );
};
function Y() {
  return {
    name: "segment-plugin",
    page: (...e) => {
      u(
        window.analytics,
        _("nully"),
        v((n) => {
          n.page(...e);
        })
      );
    },
    track: (...e) => {
      u(
        window.analytics,
        _("nully"),
        v((n) => {
          n.track(...e);
        })
      );
    },
    identify: (...e) => {
      u(
        window.analytics,
        _("nully"),
        v((n) => {
          n.identify(...e);
        })
      );
    }
  };
}
const Z = (e) => {
  const n = u(
    e.dispatch,
    y,
    p(J)
  ), t = u(
    e.plugins,
    y,
    p(() => [Y])
  );
  return u(
    M,
    R(n),
    V(e),
    W(t)
  );
};
export {
  Z as configure
};
